<template>
  <div class="case-base " v-if="HomeCase">
    <div class="case-content">
      <rl-title :show-name="HomeCase.name"/>
      <div class="content-top">
        <home-case-item v-for="item in HomeCase.photoList" :key="item.id" :case-item="item"></home-case-item>
      </div>
      <ripeav-more url-link="/case" ripeav-more="查看更多" style="margin: 0 auto"></ripeav-more>
    </div>

  </div>
</template>

<script>

import HomeCaseItem from "@/views/Home/HomeCase/HomeCaseItem";
import RipeavRightGo from "@/components/RipeavRightGo";
import RipeavShadow from "@/components/RipeavShadow";
import RipeavMore from "../../../components/RipeavMore";
import RlTitle from "@/components/Title";

export default {
  name: "HomeCase",
  components: {RlTitle, RipeavMore, RipeavShadow, RipeavRightGo, HomeCaseItem },
  props:{
    HomeCase:{

    }
  }
}
</script>

<style lang="less" scoped>
  .case-base{
    background: rgba(237,239,242,0.5);
    padding: 0 20px;

    .case-content{
      width: 74.5vw;
      margin: 0 auto;
      position: relative;
      text-align: center;
      padding-bottom: 20px;
      .content-top{
        display: flex;
        justify-content: space-between;
        margin-bottom: 60px;
      }
    }
  }
</style>